(() => {
  // A homepage may contain several multicolumn sections loading this asset.
  if (window.homepageMulticolumnImageLinksInitialized) return;
  window.homepageMulticolumnImageLinksInitialized = true;

  function enhanceImageLinks(root) {
    root.querySelectorAll('.multicolumn .multicolumn-card').forEach((card) => {
      const wrapper = card.querySelector('.multicolumn-card__image-wrapper');
      if (!wrapper || !wrapper.querySelector(':scope > .media > img.multicolumn-card__image')) return;
      if (wrapper.querySelector('.homepage-multicolumn-image-link')) return;

      // Prefer the section's button, then its existing linked heading or text.
      const destination = card.querySelector('.multicolumn-card__info .link[href]') ||
        card.querySelector('.multicolumn-card__info a[href]');
      if (!destination) return;
      const href = destination.getAttribute('href').trim();
      if (!href || href === '#' || !['http:', 'https:'].includes(destination.protocol)) return;

      // Keep Dawn's media > img structure and every image attribute untouched.
      const link = document.createElement('a');
      link.className = 'homepage-multicolumn-image-link';
      link.setAttribute('href', href);
      ['target', 'rel'].forEach((attribute) => {
        if (destination.hasAttribute(attribute)) link.setAttribute(attribute, destination.getAttribute(attribute));
      });
      // The existing text link supplies the accessible name and keyboard entry.
      link.tabIndex = -1;
      link.setAttribute('aria-hidden', 'true');
      wrapper.appendChild(link);
    });
  }

  enhanceImageLinks(document);
  document.addEventListener('shopify:section:load', (event) => enhanceImageLinks(event.target));
})();
